import { render, staticRenderFns } from "./AppLiveStreamInfo.vue?vue&type=template&id=184c6ad2&scoped=true&"
import script from "./AppLiveStreamInfo.vue?vue&type=script&lang=js&"
export * from "./AppLiveStreamInfo.vue?vue&type=script&lang=js&"
import style0 from "./AppLiveStreamInfo.vue?vue&type=style&index=0&id=184c6ad2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184c6ad2",
  null
  
)

export default component.exports